// src/router/index.js - VERSION MISE À JOUR AVEC PROTECTION ADMIN

import indexComponent from "@/component/indexComponent.vue";
import Authcomponent from "@/component/authcomponent.vue";
import { createRouter, createWebHistory } from "vue-router";
import Layout from "@/component/layout.vue";
import Accountcomponent from "@/component/accountcomponent.vue";
import Cartcomponent from "@/component/cartcomponent.vue";
import Productcomponent from "@/component/productcomponent.vue";
import Productdetails from "@/component/productdetails.vue";
import Checkout from "@/component/checkout.vue";
import Adminlayout from "@/component/admin/adminlayout.vue";
import Categorie from "@/component/admin/categorie.vue";
import Commande from "@/component/admin/commande.vue";
import Echantillons from "@/component/admin/brands.vue";
import Fournisseur from "@/component/admin/fournisseur.vue";
import Fournisseurdetail from "@/component/admin/fournisseurdetail.vue";
import Producttype from "@/component/admin/articles.vue";
import User from "@/component/admin/user.vue";
import Admindasboard from "@/component/admin/admindasboard.vue";
import Model from "@/component/admin/model.vue";
import OrderConfirmation from "@/component/OrderConfirmation.vue";
// import CategoryBrands from "@/component/categoryBrands.vue";
import store from '@/store'
import seoManager from '@/utils/seoManager'

// Import des schemas
import OrganizationSchema from '@/config/schemas/organization.schema'
import WebSiteSchema from '@/config/schemas/website.schema'
import ProductSchema from '@/config/schemas/product.schema'
import CategorySchema from '@/config/schemas/category.schema'
import BrandSchema from '@/config/schemas/brand.schema'
import BreadcrumbSchema from '@/config/schemas/breadcrumb.schema'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Layout,
    meta: {
      requiresAuth: false,
      seoType: 'home'
    },
    children: [
      {
        path: '',
        name: 'index',
        components: {
          defaultComponent: Layout,
          two: indexComponent
        },
        meta: {
          seoType: 'home'
        }
      },
      {
        path: 'account',
        name: 'account',
        components: {
          defaultComponent: Layout,
          two: Accountcomponent
        },
        meta: {
          seoType: 'account',
          robots: 'noindex, nofollow',
          requiresAuth: true // Nécessite une authentification
        }
      },
      {
        path: 'cart',
        name: 'cart',
        components: {
          defaultComponent: Layout,
          two: Cartcomponent
        },
        meta: {
          seoType: 'cart',
          robots: 'noindex, nofollow',
          requiresAuth: true // Nécessite une authentification pour le panier
        }
      },
      {
        path: 'product/:category?/:slug',
        name: 'product',
        components: {
          defaultComponent: Layout,
          two: Productdetails
        },
        meta: {
          seoType: 'product'
        }
      },
      {
        path: 'category/:category?/:brands?',
        name: 'category',
        components: {
          defaultComponent: Layout,
          two: Productcomponent
        },
        meta: {
          seoType: 'category'
        }
      },
      // {
      //   path: 'category/:category/:brands',
      //   name: 'CategoryBrands',
      //   components: {
      //     defaultComponent: Layout,
      //     two: CategoryBrands
      //   },
      //   meta: {
      //     seoType: 'brands'
      //   }
      // },
      {
        path: 'checkout',
        name: 'checkout',
        components: {
          defaultComponent: Layout,
          two: Checkout
        },
        meta: {
          seoType: 'checkout',
          robots: 'noindex, nofollow',
          requiresAuth: true // Nécessite une authentification pour le checkout
        }
      },
      {
        path: 'order-confirmation',
        name: 'order-confirmation',
        components: {
          defaultComponent: Layout,
          two: OrderConfirmation
        },
        meta: {
          seoType: 'order-confirmation',
          robots: 'noindex, nofollow',
          requiresAuth: true // Nécessite une authentification pour la confirmation
        }
      }
    ]
  },
  
  {
    path: '/auth',
    name: 'auth',
    component: Authcomponent,
    meta: {
      seoType: 'auth',
      robots: 'noindex, nofollow',
      guestOnly: true // Accessible seulement aux invités
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Adminlayout,
    meta: {
      robots: 'noindex, nofollow',
      requiresAuth: true,
      requiresAdmin: true // Nécessite le rôle admin
    },
    children: [
      {
        path: 'categorie',
        name: 'categorie',
        components: { tree: Categorie },
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'commandes',
        name: 'commandes',
        components: { tree: Commande },
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'brands',
        name: 'brands',
        components: { tree: Echantillons },
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'produits',
        name: 'produits',
        components: { tree: Model },
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'fournisseur',
        name: 'fournisseur',
        components: { tree: Fournisseur },
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        components: { tree: Admindasboard },
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'fournisseurs/:id?',
        name: 'founisseursingle',
        components: { tree: Fournisseurdetail },
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'articles',
        name: 'articles',
        components: { tree: Producttype },
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'users',
        name: 'users',
        components: { tree: User },
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

/**
 * Vérifie si l'utilisateur a le rôle admin
 */
function isAdminUser() {
  try {
    // Récupérer l'utilisateur depuis le store ou localStorage
    const user = store.state.user || JSON.parse(localStorage.getItem('user') || '{}');
    
    // Vérifier le rôle admin (selon votre structure de données)
    if (user.role === 1 || user.is_admin === true || user.is_admin === 1) {
      return true;
    }
    
    // Vérifier aussi dans les données de l'API
    if (user.role === 1) { // Si vous utilisez des ID de rôle
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('Erreur lors de la vérification du rôle admin:', error);
    return false;
  }
}

/**
 * Vérifie si l'utilisateur est authentifié
 */
function isAuthenticated() {
  // Vérifier le token dans le store et localStorage
  const token = store.state.token || localStorage.getItem('token');
  return !!token;
}

/**
 * Met à jour le SEO en fonction de la route
 */
async function updateSEO(to) {
  const seoType = to.meta.seoType
  
  // Pages sans SEO spécial (admin, etc)
  if (!seoType) {
    if (to.meta.robots) {
      seoManager.updateMetaTag('robots', to.meta.robots)
    }
    return
  }

  try {
    let seoData = null
    let schemas = []

    // Générer le SEO selon le type de page
    switch (seoType) {
      case 'home':
        seoData = seoManager.generateHomeSEO()
        // Schemas pour la page d'accueil
        schemas = [
          OrganizationSchema(),
          WebSiteSchema()
        ]
        break

      case 'product':
        if (to.params.slug) {
          // Récupérer le produit
          let product = store.state.allProducts.find(p => p.slug === to.params.slug)
          
          if (!product) {
            try {
              product = await store.dispatch('fetchProduct', to.params.slug)
            } catch (error) {
              console.error('Erreur chargement produit pour SEO:', error)
            }
          }

          if (product) {
            seoData = seoManager.generateProductSEO(product)
            
            // Schemas pour le produit
            const productSchema = ProductSchema(product)
            
            // Breadcrumb
            const breadcrumbItems = [
              { name: 'Accueil', url: `${seoManager.baseUrl}/` },
              { 
                name: product.category?.name || 'Produits', 
                url: `${seoManager.baseUrl}/category/${product.category?.slug || 'all'}` 
              },
              { 
                name: product.name, 
                url: `${seoManager.baseUrl}/product/${product.slug}` 
              }
            ]
            const breadcrumbSchema = BreadcrumbSchema(breadcrumbItems)
            
            schemas = [productSchema, breadcrumbSchema]
            
            // Mettre à jour le store
            store.commit('setPageMeta', {
              ...seoData,
              product: product
            })
          }
        }
        break

      case 'category':
        if (to.params.category) {
          // Récupérer la catégorie
          const categorySlug = to.params.category
          let category = store.state.categories.find(c => c.slug === categorySlug)
          
          if (category) {
            const productsCount = store.state.allProducts.filter(p => 
              p.category?.slug === categorySlug
            ).length
            
            seoData = seoManager.generateCategorySEO(category, productsCount)
            
            // Schemas pour la catégorie
            const categorySchema = CategorySchema(category)
            
            // Breadcrumb
            const breadcrumbItems = [
              { name: 'Accueil', url: `${seoManager.baseUrl}/` },
              { 
                name: category.name, 
                url: `${seoManager.baseUrl}/category/${category.slug}` 
              }
            ]
            const breadcrumbSchema = BreadcrumbSchema(breadcrumbItems)
            
            schemas = [categorySchema, breadcrumbSchema]
            
            // Mettre à jour le store
            store.commit('setPageMeta', {
              ...seoData,
              category: category
            })
          }
        }
        break
        case 'brands':
        if (to.params.brands) {
          // Récupérer la catégorie
          const brandSlug = to.params.brands
          let brand = store.state.brands.find(c => c.slug === brandSlug)
          
          if (brand) {
            const productsCount = store.state.allProducts.filter(p => 
              p.brand?.slug === brandSlug
            ).length
            
            seoData = seoManager.generateBrandSEO(brand, productsCount)
            
            // Schemas pour la catégorie
            const BrandSchema = BrandSchema(brand)
            
            // Breadcrumb
            const breadcrumbItems = [
              { name: 'Accueil', url: `${seoManager.baseUrl}/` },
              { 
                name: brand.name, 
                url: `${seoManager.baseUrl}/category/${brand.categorySlug}/${brand.slug}` 
              }
            ]
            const breadcrumbSchema = BreadcrumbSchema(breadcrumbItems)
            
            schemas = [BrandSchema, breadcrumbSchema]
            
            // Mettre à jour le store
            store.commit('setPageMeta', {
              ...seoData,
              brand: brand
            })
          }
        }
        break

      case 'cart':
        seoData = {
          title: 'Mon Panier - cassuss E-commerce',
          description: 'Vérifiez vos articles avant de finaliser votre commande.',
          robots: 'noindex, nofollow',
          url: `${seoManager.baseUrl}/cart`
        }
        break

      case 'checkout':
        seoData = {
          title: 'Finaliser ma commande - cassuss E-commerce',
          description: 'Finalisez votre commande en toute sécurité.',
          robots: 'noindex, nofollow',
          url: `${seoManager.baseUrl}/checkout`
        }
        break

      case 'account':
        seoData = {
          title: 'Mon Compte - cassuss E-commerce',
          description: 'Gérez votre compte et vos commandes.',
          robots: 'noindex, nofollow',
          url: `${seoManager.baseUrl}/account`
        }
        break

      case 'auth':
        seoData = {
          title: 'Connexion / Inscription - cassuss E-commerce',
          description: 'Connectez-vous ou créez un compte pour commander.',
          robots: 'noindex, nofollow',
          url: `${seoManager.baseUrl}/auth`
        }
        break

      default:
        seoData = seoManager.generateHomeSEO()
    }

    // Appliquer les meta tags
    if (seoData) {
      seoManager.setMetaTags(seoData)
    }

    // Nettoyer les anciens schemas
    seoManager.clearSchemas()

    // Injecter les nouveaux schemas
    schemas.forEach((schema, index) => {
      const schemaId = `${seoType}-${schema['@type']}-${index}`
      seoManager.injectSchema(schema, schemaId)
    })

    console.log(`🎯 SEO configuré pour: ${seoType}`, seoData?.title)

  } catch (error) {
    console.error('Erreur lors de la configuration du SEO:', error)
  }
}

/**
 * Middleware de protection des routes
 */
async function routeGuard(to, from, next) {
  // Appliquer le SEO
  await updateSEO(to);
  
  // Récupérer les métadonnées de la route
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const guestOnly = to.matched.some(record => record.meta.guestOnly);
  
  // Vérifier l'authentification
  const authenticated = isAuthenticated();
  
  // Routes nécessitant une authentification
  if (requiresAuth && !authenticated) {
    // Rediriger vers la page d'authentification avec la route de retour
    next({
      path: '/auth',
      query: { 
        redirect: to.fullPath,
        tab: 'login'
      }
    });
    return;
  }
  
  // Routes nécessitant le rôle admin
  if (requiresAdmin && authenticated) {
    const isAdmin = isAdminUser();
    
    if (!isAdmin) {
      // Rediriger vers la page d'accueil si pas admin
      next('/');
      return;
    }
  }
  
  // Routes accessibles seulement aux invités (comme /auth)
  if (guestOnly && authenticated) {
    // Rediriger vers le compte si déjà connecté
    next('/account');
    return;
  }
  
  // Autoriser la navigation
  next();
}

// Middleware avant chaque navigation
router.beforeEach(routeGuard);

// Après chaque navigation (pour rafraîchir si besoin)
router.afterEach((to) => {
  // Pour les pages produit, on peut rafraîchir après le montage du composant
  if (to.meta.seoType === 'product' && to.params.slug) {
    setTimeout(async () => {
      try {
        const product = await store.dispatch('fetchProduct', to.params.slug)
        if (product) {
          const seoData = seoManager.generateProductSEO(product)
          seoManager.setMetaTags(seoData)
          
          const productSchema = ProductSchema(product)
          seoManager.injectSchema(productSchema, 'product-refresh')
          
          console.log('🔄 SEO produit rafraîchi')
        }
      } catch (error) {
        console.error('Erreur rafraîchissement SEO:', error)
      }
    }, 500)
  }
})

export default router
